import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="max-w-md">
      <h2 className="mb-2 text-lg font-semibold">{t("notFound.title")}</h2>
      <p className="mb-4 text-sm text-slate-500">{t("notFound.subtitle")}</p>
      <Link to="/" className="text-xs text-blue-600 hover:underline">
        {t("notFound.back")}
      </Link>
    </div>
  );
}
